import { ERROR_TEXT_LIST } from "views/components/Duration/utils/constants";
import { TYPES } from "./acadReinforce.actions";

export const INITIAL_STATE = {
    currentStep: 1,
    form: {
        step1: {
            part1: {
                title: "",
                acadReinforceTypeId: 0,
                course: {
                    id: "",
                    catalogCode: "",
                    name: ""
                }
            },
            part2: {
                tutor: {
                    id: "",
                    fullName: ""
                },
                payGradeId: ""
            },
            part3: {
                quantityVacancy: "",
                publicLoad: {
                    id: 0, 
                    students: {
                        publicByCampusIds: []
                    }, 
                    list: {
                        studentsFile: {
                            name: "",
                            size: 0,
                            base64: ""
                        }
                    }
                }
            },
        },
        step2: {
            part1: {
                description: "",
                standOutAcadReinforce: false 
            }, 
            part2: {
                duration: {
                    date: -1, 
                    time: {
                        start: -1,
                        end: -1 
                    }
                }
            },
            part3: {
                locationId: 0,
                zoomInscriptionTypeId: 0,
                place: {
                    campus: {
                        id: 0,
                        name: ""
                    },
                    environmentTypeId: "",
                    environment: {
                        id: "",
                        environmentCode: "",
                        address: "",
                        floor: "",
                        capacity: ""
                    },
                    environmentFillingTypeId: 1,
                    otherEnvironment: {
                        envName: "",
                        address: "",
                        floor: "",
                        capacity: ""
                    }
                }
            }
        }
    },
    errors: {
        step1: {
            part1: {
                acadReinforceTypeId: false,
                course: false
            },
            part2: {
                tutor: false,
                payGradeId: false
            },
            part3: {
                quantityVacancies: false,
                publicLoad: {
                    id: false, 
                    students: {
                        publicByCampusIds: false, 
                        modalityId: false
                    }, 
                    list: {
                        studentsFile: false
                    }
                }
            }
        },
        step2: {
            part2: {
                duration: {
                    date: false, 
                    time: {
                        start: false,
                        end: false 
                    },
                    areInvalidTimes: false
                }
            },
            part3: {
                locationId: false,
                zoomInscriptionTypeId: false,
                place: {
                    campus: false,
                    environmentTypeId: false,
                    environment: false,
                    otherEnvironment: {
                        envName: false,
                        address: false,
                        floor: false,
                        capacity: false
                    }
                }
            }
        }
    },
    errorTexts: {
        invalidTimes: ERROR_TEXT_LIST.INVALID_TIMES,
        tutorSearch: "Agrega al tutor(a) a cargo",
        location: "Es necesario seleccionar una ubicación"
    }
};
//#region Functions
const changeFieldForm = (
    prev, step, 
    {  
        part, field, 
        value, errorValue = null 
    }) => {
    let newState = {
        ...prev, 
        form: {
            ...prev.form,
            [step]: {
                ...prev.form[step],
                [part]: {
                    ...prev.form[step][part],
                    [field]: typeof value === "function" ? value(prev.form[step][part][field]) : value
                }
            }
        }
    };
    if (errorValue !== null)
        newState = {
            ...newState,
            errors: {
                ...prev.errors, 
                [step]: {
                    ...prev.errors[step],
                    [part]: {
                        ...prev.errors[step][part],
                        [field]: typeof errorValue === "function" ? errorValue(prev.errors[step][part][field]) : errorValue
                    }
                }
            }
        };
    return newState;
}
const changeErrorFormForStep = (prev, step, value) => {
    return {
        ...prev,
        errors: {
            ...prev.errors, 
            [step]: value
        }
    };
}
const changeAllForm = (prev, form) => {
    const { errors } = INITIAL_STATE;
    return {
        ...prev,
        form, 
        errors: { ...errors }
    };
}
//#endregion

const reducer = (state, action) => {
    switch (action.type) {
        case TYPES.NEXT_STEP: 
            return { 
                ...state, 
                currentStep: state.currentStep + 1
            };
        case TYPES.BACK_STEP: 
            return { 
                ...state, 
                currentStep: state.currentStep - 1
            };
        case TYPES.TO_STEP: 
            return {
                ...state,
                currentStep: action.payload.step
            };
        case TYPES.SET_FORM_STEP_1: 
            return changeFieldForm(
                state, "step1", 
                action.payload.entries);
        case TYPES.SET_FORM_STEP_2: 
            return changeFieldForm(
                state, "step2", 
                action.payload.entries);
        case TYPES.SET_FORM_ERRORS_STEP_1:
            return changeErrorFormForStep(
                state, "step1", 
                action.payload.value);
        case TYPES.SET_FORM_ERRORS_STEP_2:
            return changeErrorFormForStep(
                state, "step2", 
                action.payload.value);
        case TYPES.SET_FORM: 
            const { form } = action.payload;
            return changeAllForm(state, form);
        case TYPES.SET_ERROR_TEXT:
            const { field, text } = action.payload;
            return {
                ...state, 
                errorTexts: {
                    ...state.errorTexts, 
                    [field]: text
                }
            };
        default: 
            return state;
    }
}

export default reducer;